import React from 'react'
import { Field } from 'redux-form'
import { TextArea } from 'semantic-ui-react'

import FormFieldWrapper from './field'

const FormTextArea = props => {
  return(
    <Field
      component={FormFieldWrapper}
      fieldType={TextArea}
      {...props}
    />
  )
}

export default FormTextArea
